import { useSelector } from "react-redux";

import useArePushNotificationsSupported from "services/firebase/messaging/hooks/useArePushNotificationsSupported";

import { isPlurallApp } from "features/plurall";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";
import { isSchoolParent } from "features/user";

import { PreferencesType } from "../types";

export default function useGetPreferencesTypes(): PreferencesType[] {
  const isPushSupported =
    useArePushNotificationsSupported() || isNativeAppiOS();

  const isParent = useSelector(isSchoolParent);
  const isPlurall = useSelector(isPlurallApp);

  const showEmailAndPush = isPushSupported && isParent && !isPlurall;

  return showEmailAndPush ? ["email", "push"] : ["email"];
}
